<svg width="35" height="34" fill="none">
    <path
        stroke="#020621"
        stroke-width="1.2"
        d="M28.1951 22.7734c-.6563 0-1.2793.261-1.7494.7328-.4708.4772-.7333 1.0985-.7333 1.7647 0 .6661.2572 1.288.7333 1.7652.4755.4717 1.0931.7322 1.7494.7322 1.3455 0 2.4392-1.121 2.4392-2.4974 0-1.3765-1.0937-2.4975-2.4392-2.4975ZM12.2176 22.9346c-.6563 0-1.2793.2584-1.75.7255-.47021.4724-.73274 1.0877-.73274 1.7472 0 .6595.25715 1.2753.73274 1.7478.4755.4671 1.0937.7249 1.75.7249 1.3449 0 2.4392-1.1098 2.4392-2.4727 0-1.3629-1.0943-2.4727-2.4392-2.4727Z"
        clip-rule="evenodd"
    />
    <path
        stroke="#020621"
        stroke-width="1.2"
        d="M8.46785 23.338h-2.1802c-.27758 0-.50249-.2283-.50249-.5107v-2.7365M9.92798 18.4795H1.59961M11.3356 15.6805l-8.32836-.0487h-.00675M8.21964 12.832H0M23.8822 23.3379h-.7653c-.2775 0-.5031-.2282-.5031-.5107V9.8352c0-.28174.2256-.51.5031-.51h4.8494c.1169 0 .2303.04112.3208.11721l5.5275 4.64689c.1155.0967.1824.2406.1824.3928v8.3424c0 .2831-.227.5121-.5059.51l-1.7351-.011"
    />
    <path
        stroke="#020621"
        stroke-width="1.2"
        d="M5.78467 11.2208V6.63081c0-.28174.22491-.51069.50317-.51069H22.0888c.2776 0 .5025.22895.5025.51069V22.8275c0 .2824-.2249.5107-.5025.5107h-5.7436"
    />
    <path
        stroke="#020621"
        stroke-width="1.2"
        d="M24.6045 16.9471v-5.0897c0-.2825.2249-.5107.5032-.5107h2.141c.1168 0 .2303.0418.3208.1172l4.2537 3.5762c.1155.0966.1823.2406.1823.3928v1.5142c0 .2817-.2249.51-.5031.51h-6.3947c-.2783 0-.5032-.2283-.5032-.51Z"
        clip-rule="evenodd"
    />
</svg>
